import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import DOMPurify from "dompurify";
import React, { useMemo, useState } from "react";
import { detectarTagsHtml, retirarTagsHtml } from "../../../Tools/FormatTools";
import ModalComponent from "../../Modais";
import { IComponentModal } from "../../Modais/IModalComponent";
import LeiaMais, { ILeiaMaisProps } from "../LeiaMais";
import useAsyncEffect from "../../../hooks/useAsyncEffect";
import OrSpinner from "../OrSpinner";

interface IHTMLViewrProps extends Partial<ILeiaMaisProps> {
    children: string;
    onlyRemove?: true;
}

export default function HTMLRemover(props: IHTMLViewrProps) {
    const STR_IS_HTML = useMemo(
        () => detectarTagsHtml(props.children),
        [props.children]
    );
    const STR_HTML_FREE = useMemo(
        () => (STR_IS_HTML ? retirarTagsHtml(props.children) : props.children),
        [STR_IS_HTML, props.children]
    );

    const [modal, setModal] = useState<IComponentModal>();
    const [show, setShow] = useState(false);
    const leiaMaisProps: ILeiaMaisProps = {
        ...props,
        charLimit: props.charLimit ?? 300,
        children: STR_HTML_FREE ?? "",
    };

    const { value: historicoComLinkDoDriveSubstituido, loading } =
    useAsyncEffect(async () => {
        // cria o template e coloca a string nele
        const template = document.createElement("template");
        template.innerHTML = props.children;

        // pega as imagens que tem src com link do drive
        const imgNodes = template.content.querySelectorAll(
            'img[src^="https://docs.google.com/uc?id="]'
        ) as NodeListOf<HTMLImageElement>;

        imgNodes.forEach((img) => {
            if (img.src.includes("https://docs.google.com/uc?id=")) {
                // Substitui parte da URL para obter a miniatura do Google Drive
                img.src = img.src.replace("https://docs.google.com/uc?id=", "https://drive.google.com/thumbnail?id=");
                img.src += "&sz=w1000";
            }
        });

        // Retorna o conteúdo do template após a substituição
        return template.innerHTML;
    });

    return (
        <>
            {props.onlyRemove ? (
                STR_HTML_FREE
            ) : (
                <>
                    <span>
                        {STR_IS_HTML && (
                            <span
                                className="text-primary ml-1 btn p-0"
                                onClick={() => {
                                    setModal({
                                        Component: () => (
                                            <OrSpinner
                                                wrapperLoadingClasses="w-100 d-flex align-items-center justify-content-center"
                                                loading={loading}
                                                loadingColor="primary"
                                            >
                                                <div
                                                    dangerouslySetInnerHTML={{
                                                        __html: DOMPurify.sanitize(
                                                            historicoComLinkDoDriveSubstituido ?? props.children
                                                        ),
                                                    }}
                                                    className="modalHtml"
                                                ></div>
                                            </OrSpinner>
                                        ),
                                        noHeader: true,
                                        noFooter: true,
                                        size: "xl",
                                        scrollable: true,
                                    });
                                    setShow(true);
                                }}
                            >
                                <FontAwesomeIcon icon={faSearch} />
                            </span>
                        )}
                        <LeiaMais {...leiaMaisProps} />
                    </span>
                    <ModalComponent
                        show={show}
                        setShow={setShow}
                        ModalComponent={modal}
                    />
                </>
            )}
        </>
    );
}
